var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.115 3.3291C16.3254 3.32911 16.5177 3.44788 16.612 3.63596C16.7064 3.82436 16.6861 4.04995 16.5597 4.21855L11.6678 10.791V14.7251C11.6672 15.0749 11.5025 15.4042 11.223 15.6146L10.1112 16.4484C9.91892 16.593 9.68476 16.6711 9.44416 16.6708C8.83202 16.6662 8.33689 16.1711 8.33235 15.559V10.791L3.44041 4.21855C3.31407 4.0501 3.29375 3.82473 3.38792 3.6364C3.48208 3.44807 3.67457 3.3291 3.88513 3.3291H16.115ZM8.53025 7.47058L6.34055 4.55209C6.28841 4.48257 6.20676 4.44143 6.11986 4.44091H5.56396C5.45868 4.44091 5.36243 4.50039 5.31535 4.59456C5.26827 4.68872 5.27843 4.80141 5.34159 4.88563L8.08553 8.499C8.15731 8.59471 8.28229 8.63375 8.39579 8.59591C8.50929 8.55808 8.58584 8.45187 8.58584 8.33223V7.63735C8.58584 7.57721 8.56634 7.51869 8.53025 7.47058Z",
    fill: "#036DAD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_210_2956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.115 3.3291C16.3254 3.32911 16.5177 3.44788 16.612 3.63596C16.7064 3.82436 16.6861 4.04995 16.5597 4.21855L11.6678 10.791V14.7251C11.6672 15.0749 11.5025 15.4042 11.223 15.6146L10.1112 16.4484C9.91892 16.593 9.68476 16.6711 9.44416 16.6708C8.83202 16.6662 8.33689 16.1711 8.33235 15.559V10.791L3.44041 4.21855C3.31407 4.0501 3.29375 3.82473 3.38792 3.6364C3.48208 3.44807 3.67457 3.3291 3.88513 3.3291H16.115ZM8.53025 7.47058L6.34055 4.55209C6.28841 4.48257 6.20676 4.44143 6.11986 4.44091H5.56396C5.45868 4.44091 5.36243 4.50039 5.31535 4.59456C5.26827 4.68872 5.27843 4.80141 5.34159 4.88563L8.08553 8.499C8.15731 8.59471 8.28229 8.63375 8.39579 8.59591C8.50929 8.55808 8.58584 8.45187 8.58584 8.33223V7.63735C8.58584 7.57721 8.56634 7.51869 8.53025 7.47058Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_210_2956)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter2);
export default __webpack_public_path__ + "static/media/filter-2.5bfd0defd3791a418b33ac856dbd551c.svg";
export { ForwardRef as ReactComponent };